import { useEffect } from "react";

export default function useEditorialMotion(rootRef) {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    const sections = Array.from(
      root.querySelectorAll("main > section:not(:first-child)"),
    );

    root.classList.add("av-motion-ready");
    sections.forEach((section) => section.classList.add("av-reveal-section"));

    const revealAll = () => {
      sections.forEach((section) => section.classList.add("is-visible"));
    };

    const prefersReducedMotion =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      revealAll();
      return () => root.classList.remove("av-motion-ready");
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -9%", threshold: 0.08 },
    );

    sections.forEach((section) => observer.observe(section));

    return () => {
      observer.disconnect();
      root.classList.remove("av-motion-ready");
    };
  }, [rootRef]);
}
